import { WindPowerOutlineIcon } from './WindPowerOutlineIcon';

/**
 * author: Google
 * id 4ED15D1F-9A58-4E07-BA71-3DCEAC67F59D
 * name wind-power-outline
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wind-power-outline.svg
 * tags
 * - Home Automation 
 */
export const WindElectricityOutlineIcon = WindPowerOutlineIcon;
export default WindElectricityOutlineIcon